import React from "react";
import {useHttp} from "../../../services/HttpService";
import {
    getAnlagenSystemEndpoint,
    getBiologischeBehandlungEndpoint,
    getChemischeBehandlungEndpoint,
    getNachbehandlungEndpoint,
    getSchlammbehandlungEndpoint,
    getVorbehandlungEndpoint
} from "../../../services/WertelistenService";


export default function AnlagensystemSelector(props) {
    const [anlagensystem] = useHttp(getAnlagenSystemEndpoint);
    const [biologischeBehandlung] = useHttp(getBiologischeBehandlungEndpoint);
    const [schlammbehandlung] = useHttp(getSchlammbehandlungEndpoint);
    const [vorbehandlung] = useHttp(getVorbehandlungEndpoint);
    const [chemischeBehandlung] = useHttp(getChemischeBehandlungEndpoint);
    const [nachbehandlung] = useHttp(getNachbehandlungEndpoint);

    return (
        <div className="gridl" style={{gridTemplateColumns: "1fr 1fr 1fr"}}>
            {props.formFactory.renderAutocomplete(
                "anlagensystem",
                "anlagensystem",
                "Anlagensystem",
                anlagensystem.data,
                "value",
                "id",
                anlagensystem.loading,
                false,
                props.isDisabled,
            )}
            {props.formFactory.renderAutocomplete(
                "biologischeBehandlung",
                "biologischeBehandlung",
                "Biologische Behandlung",
                biologischeBehandlung.data,
                "value",
                "id",
                biologischeBehandlung.loading,
                false,
                props.isDisabled,
            )}
            {props.formFactory.renderAutocomplete(
                "schlammbehandlung",
                "schlammbehandlung",
                "Schlammbehandlung/-entsorgung",
                schlammbehandlung.data,
                "value",
                "key",
                schlammbehandlung.loading,
                false,
                props.isDisabled
            )}
            {props.formFactory.renderAutocomplete(
                "vorbehandlung",
                "vorbehandlung",
                "Vorbehandlung",
                vorbehandlung.data,
                "value",
                "key",
                vorbehandlung.loading,
                false,
                props.isDisabled
            )}
            {props.formFactory.renderAutocomplete(
                "chemischeBehandlung",
                "chemischeBehandlung",
                "Chemische Behandlung",
                chemischeBehandlung.data,
                "value",
                "key",
                chemischeBehandlung.loading,
                false,
                props.isDisabled
            )}
            {props.formFactory.renderAutocomplete(
                "nachbehandlung",
                "nachbehandlung",
                "Nachbehandlung/Abtrennung",
                nachbehandlung.data,
                "value",
                "key",
                nachbehandlung.loading,
                false,
                props.isDisabled
            )}
        </div>
    );
}
